export class UserPackageChangeConfiguration {
  constructor(public userId: number) {}
}
